import AddNewFolderCardContainer from './AddNewFolderCard.container';
import AddNewFolderCard from './AddNewFolderCard';

export default AddNewFolderCardContainer(AddNewFolderCard);
